<template>
  <div class="closingWrapper">
     <a v-if="showBtn" href="#" class="getClosingBtn" @click.prevent="getLastClosing">Fill from Last</a>
     <div  class="foundDate m-t-5" v-if="showFoundDate">Found: {{ moment(foundDate).format('DD-MM-YYYY') }} 
       <i class="fa fa-times-circle text-danger" aria-hidden="true" @click="showFoundDate = false"></i>
     </div>
  </div>
</template>

<script>
import MaterialStockService from '../../../../../services/material-stock.service';
import EventBus from '../../../../../EventBus';

  export default {
     props: {
       recordDate: {
         type: String,
         default: ''
       },
       materialId: {
         type: Number,
         default: null
       },
       showBtn: {
         type: Boolean, 
         default: false
       }
     },
     data(){
       return {
         foundDate: null,
         showFoundDate: false
       }
     },
     methods: {
       async getLastClosing(){
         try{
           let data = {
              date: this.recordDate,
              materialId: this.materialId
           }
           const lastValue = await MaterialStockService.getLastClosingValue(data);
           this.foundDate = lastValue.data.lastRecord.onDate;
           const {openingStock, inBound, outBound, adjustment} = lastValue.data.lastRecord;
           const openingValue  =  this.calculateClosingValue(openingStock, inBound, outBound, adjustment)

           EventBus.$emit("material-stock.fill-opening-value", {openingValue, materialId: this.materialId})
           this.showFoundDate = true;

          

         }catch(errors){
           console.log(errors)
         }
       },
       calculateClosingValue(openingStock=0, inBound=0, outBound=0, adjustment=0){
          
          openingStock = parseFloat(openingStock ? openingStock : 0);
          inBound = parseFloat(inBound ? inBound : 0);
          outBound = parseFloat(outBound ? outBound : 0);
          adjustment = parseFloat(adjustment ? adjustment : 0);

          console.log(openingStock, inBound, outBound, adjustment)

          return (openingStock + inBound) - (outBound + adjustment)
       }
     }
  }
</script>

<style lang="scss" scoped>
  .closingWrapper{
    width: 100%;

  }
  .getClosingBtn{
     font-size: 12px;
     background-color: rgb(255, 111, 27);
     display: inline-block;
     padding: 1px 10px;
     color: #fff;
     text-decoration: none;
     border-radius: 3px;
  }
  .foundDate{
    font-size: 12px;
    transition: all 300ms ease;
  }
</style>